module.exports = __webpack_public_path__ + "cuttingline1.png?005e4a830498b927653074ef4fead5f8";